angular.module('impactx.address').controller('UserAddressDetailCtrl', UserAddressDetailCtrl);
UserAddressDetailCtrl.$inject = ['$scope',
    'dataGen', 'selectedListItems',
    '$mdToast', 'BackService',
    '$routeParams',
    'ConfirmationService',
    'ToolbarService'
];

/**
 * Thanks to AddressDirectiveController this one does not need to deal with pre-set data anymore.
 */
function UserAddressDetailCtrl($scope, dataGen, selectedListItems, $mdToast, BackService, $routeParams, ConfirmationService, ToolbarService) {
    var adrId, ctrl = this;

    var ADDRESS_SIZE = 'FULL_DIALOG';
    $scope.expandAddress = false;
    $scope.expandContact = false;
    $scope.data = {};


    if($routeParams.id) {
        adrId = $routeParams.id;
    }
    else if(selectedListItems.getFirstSelectedId()) {
        adrId = selectedListItems.getFirstSelectedId();
    }
    else {
        adrId = 0;
    }
    
    ctrl.checkVisible = function(field){
        if(field) {
            return field.visible || false;
        }
        return false;
    };

    ctrl.checkRequired = function (field) {
        if (field) {
            if (field.showMust) {
                return true;
            }
            return field.requiredIfContactAddress && $scope.data.adr.isContactAddress.value
        }
        return false;
    }

    ctrl.prepareDataForSave = function(data) {
        var dataToSend = {};

        angular.copy(data, dataToSend);

        //slim down relations
        if(dataToSend.userRelation && dataToSend.userRelation.relation) {
            dataToSend.userRelation.relation.available = [];
        }

        if(dataToSend.companyRelation && dataToSend.companyRelation.relation) {
            dataToSend.companyRelation.relation.available = [];
        }

        dataToSend.country = dataGen.slimDownPopup(dataToSend.country);

        return dataToSend;
    };

    ctrl.saveUser = function(saveCopy) {
        $scope.data.adr.addressSize = ADDRESS_SIZE;
        const dataToSave  = angular.copy($scope.data.adr);
        delete dataToSave.country.entries;
        
        var entryPoint = saveCopy ? "/address/saveasuser" : "/address/saveuser";
        return dataGen.postAsForm($scope, {address: dataToSave}, entryPoint).then(function() {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.save_success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
            BackService.back(true);
        })
    };

    ctrl.handleNuts = function() {
        var address,
            scope = {};

        address = $scope.data.adr;

        if(address.zip && address.country.selected) {
            return dataGen.postAsForm(scope, {
                zip: address.zip.value,
                ctyId: address.country.selected.id
            }, "/address/ziptonuts").then(function() {
                var bestNuts, availableNuts, currentNuts;

                currentNuts = address.nutsCode;
                bestNuts = scope.data.bestCode;
                availableNuts = scope.data.options;

                if((currentNuts && availableNuts.indexOf(currentNuts) !== -1) || !address.nuts) {
                    address.nutsCode.value = bestNuts;
                }

                $scope.availableNuts = availableNuts;
            });
        }
    };

    ctrl.deleteDialogUser = function(event) {
        ConfirmationService.showConfirmationDialog(ctrl.deleteUser, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.deleteUser = function() {
        var dataObj = {
            id: $scope.data.adr.addressId
        };
        dataGen.postAsForm($scope, dataObj, "/address/deleteuser").then(function() {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.toggleAdditionalFields = function () {
        angular.forEach($scope.data.adr.additionalFields, function (fieldName) {
            var field = impactX.isDefined($scope, 'data.adr.'+fieldName);
            if (field && !(field.value || ctrl.hasPhoneValue(field))) {
                field.visible = !field.visible;
            }
        })
    }

    ctrl.hasPhoneValue = function (field) {
        return impactX.isDefined(field, 'coutryCode.value') ||
            impactX.isDefined(field, 'areaCode.value') ||
            impactX.isDefined(field, 'networkCode.value') ||
            impactX.isDefined(field, 'numberCode.value');
    }

    dataGen.getData({}, {id: adrId, size: ADDRESS_SIZE}, "/address/viewuser").then(function(data) {
        if (!$scope.data)
        {
            $scope.data = {};
        }
        $scope.data.adr = data.data.adr;
        $scope.trns = data.trns;
        ctrl.handleNuts();
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: function () {
                    return ctrl.saveUser(false);
                },
                type: 'validation',
                condition: canEdit,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.saveAs,
                action: function () {
                    return ctrl.saveUser(true);
                },
                type: 'validation',
                condition: canCreate,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialogUser,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.toggleAdditional,
                action: ctrl.toggleAdditionalFields,
                type: 'dialogaction',
                condition: canToggle
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canEdit() {
        return impactX.isDefined($scope, 'data.adr.hasRightToEdit');
    }

    function canCreate() {
        var adr = impactX.isDefined($scope, 'data.adr');
        return adr.hasRightToCreate && adr.addressId > 0;
    }

    function canDelete() {
        return !$scope.data.adr.readOnly && $scope.data.adr.hasRightToDelete;
    }

    function canToggle() {
        return $scope.data.adr.additionalFields && $scope.data.adr.additionalFields.length > 0;
    }
}